<template>
  <section v-if="publication">
    <div id="publicationPattern" class="ml-0 ml-md-1 ml-lg-2">
      <p v-if="publication.type!=8" class="text-left text-body-1 text-md-body-2 font-weight-bold pl-1 pb-1 mb-0">{{listTypePublication[publication.type]}}</p>
      <app-thesis-pattern v-if="publication.type==7" :thesis="thesis" :icon=false></app-thesis-pattern>
      <app-lecture-pattern v-if="publication.type==8" :lecture="lecture" :icon=false ></app-lecture-pattern>
      <app-production-list-grants class="ml-1" v-if="publication.grants" :grants="publication.grants" :icon=false></app-production-list-grants>
      <a v-if="publication.url_repository" :href="publication.url_repository" target="_blanc">
        <p class="indigo--text text--darken-2 text-body-2 text-md-caption font-weight-medium  ml-1 px-0 pt-1 pb-0 my-0">Repository</p>
      </a>
      <p v-if="bo">
            <section v-if="publication.type!=6" >
                <v-btn v-if="publication.type!=7"
                    x-small class="mt-0 ml-2 white--text" color="green darken-4"
                    :to="{name:'publication.bo.edit',params: { type:publication.type, id:publication.id }}" >
                    edit
                </v-btn>
                <v-btn
                    x-small class="mt-0 ml-2 white--text" color="red darken-4"
                    :to="{name:'publication.bo.delete',params: { type:publication.type, id:publication.id }}" >
                    delete
                </v-btn>
                
            </section>
            <section v-if="publication.type==6">
                <v-btn v-if="useractive.permissions[4][0].name == 'All Publications'"
                    x-small class="my-2 ml-n3 mr-6 py-4  white--text" color="green darken-4"
                    :to="{name:'publication.bo.modify',params: { type:publication.type,id:publication.id }}" >
                    Modify <br /> a preprint
                </v-btn>

                <section v-if="publication.generaltable.display_mode == 0">
                    <v-btn
                        x-small class="my-2 ml-n3 mr-6 py-4 white--text " color="green darken-4"
                        :to="{name:'publication.bo.tranfer',params: { type:publication.type,id:publication.id, mode:2 }}" >
                        Transfer to <br />a publication
                    </v-btn>
                    <v-btn
                        x-small class="my-2 ml-n3 mr-6 py-4  white--text" color="red darken-4"
                        :to="{name:'publication.bo.retract',params: { type:publication.type,id:publication.id, mode:1 }}" >
                        Restrict <br/> access
                    </v-btn>
                    <v-btn
                        x-small class="my-2 ml-n3 mr-6 py-4  white--text" color="red darken-4"
                        :to="{name:'publication.bo.retract',params: { type:publication.type,id:publication.id, mode:3 }}" >
                        Retract <br /> a preprint
                    </v-btn>
                </section>
            </section>    
            
      </p>
    </div>
  </section>
</template>
<script>
import {mapGetters} from 'vuex';
import productionListGrants from '../ProductionListGrants.vue';
import thesisPattern from './thesis/ThesisPattern.vue';
import lecturePattern from './lectures/LecturePattern.vue';

export default {
     props: {
        bo: {type:Boolean,
            default:false
        },
        publication:{},
    },
    data() {
        return {
            thesis:{
                // url:this.publication.url,
                // year_start:this.publication.year_start,
                // department:this.publication.department,
            },
            preprint:{
            //     url_preprint:this.publication.url_preprint,
            //     date_preprint:this.publication.date_preprint,
            //     registrat_num:this.publication.registrat_num,
             },
            lecture:{
                // monthYear:this.publication.year+'-'+this.publication.month_date,
            }
        }
    },
    created(){
            if(this.publication && this.publication.department){
                this.thesis.department =  this.publication.department;
            }
            if(this.publication && this.publication.url){
                this.thesis.url =  this.publication.url;
            }
            if(this.publication && this.publication.year_start){
                this.year_start = this.publication.year_start;
            }
            if(this.publication && this.publication.url_preprint){
                this.preprint={
                    url_preprint:this.publication.url_preprint,
                    date_preprint:this.publication.date_preprint,
                    registrat_num:this.publication.registrat_num,
                };
            }
            if(this.publication && this.publication.year){
                this.lecture={
                    monthYear:this.publication.year+'-'+this.publication.month_date,
                };
            }

    },
    components:{
        AppProductionListGrants:productionListGrants,
        AppThesisPattern:thesisPattern,
        AppLecturePattern:lecturePattern,
    },
    computed: {
        ...mapGetters('publication',{
            listTypePublication:'listTypePublication' ,
        }),
        ...mapGetters('header',{
            useractive: 'useractive',
        }),
    },
}
</script>
<style scoped>
.repository{
  text-decoration-style: solid;
}
</style>




